(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initGallery = (gallery) => {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';
    const track = gallery.querySelector('.sm-gallery-track');
    const slides = [...track.children];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-index]')];
    let index = 0;
    const update = () => {
      index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      gallery.querySelector('[data-gallery-count]').textContent = `${index + 1} / ${slides.length}`;
      gallery.querySelector('[data-gallery-prev]').disabled = index === 0;
      gallery.querySelector('[data-gallery-next]').disabled = index === slides.length - 1;
      slides.forEach((slide, i) => {
        if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());
      });
    };
    const go = (next) => track.scrollTo({left: Math.max(0, Math.min(slides.length - 1, next)) * track.clientWidth, behavior: reduceMotion ? 'instant' : 'smooth'});
    thumbs.forEach((button, i) => button.addEventListener('click', () => go(i)));
    gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => go(index - 1));
    gallery.querySelector('[data-gallery-next]').addEventListener('click', () => go(index + 1));
    track.addEventListener('scroll', update, {passive: true});
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); go(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    gallery.addEventListener('sm:media', event => {
      const next = slides.findIndex(slide => slide.dataset.mediaId === String(event.detail));
      if (next >= 0) go(next);
    });
    new ResizeObserver(() => { track.scrollLeft = index * track.clientWidth; update(); }).observe(track);
    update();
  };
  const initProduct = (product) => {
    if (product.dataset.initialized) return;
    product.dataset.initialized = 'true';
    const form = product.querySelector('.sm-buy-form');
    if (!form) return;
    const sticky = product.querySelector('[data-sticky-buy]');
    const button = form.querySelector('.sm-atc');
    const normalLabel = button.dataset.label || 'Add to bag';
    form.addEventListener('change', event => {
      const radio = event.target;
      if (radio.name !== 'id' || product.dataset.offerMode === 'kaching') return;
      product.querySelectorAll('.sm-offer').forEach(offer => offer.classList.toggle('is-selected', !!offer.querySelector('input:checked')));
      form.querySelector('[data-current-price]').textContent = radio.dataset.price;
      const available = radio.dataset.available === 'true';
      button.disabled = !available;
      button.querySelector('[data-atc-label]').textContent = available ? normalLabel : 'Sold out';
      if (sticky) {
        sticky.querySelector('[data-sticky-price]').textContent = radio.dataset.price;
        sticky.querySelector('button').disabled = !available;
        sticky.querySelector('[data-sticky-label]').textContent = available ? normalLabel : 'Sold out';
      }
      if (location.pathname.includes('/products/')) {
        const url = new URL(location.href); url.searchParams.set('variant', radio.value); history.replaceState({}, '', url);
      }
      if (radio.dataset.featuredMedia) product.querySelector('[data-sm-gallery]').dispatchEvent(new CustomEvent('sm:media', {detail: radio.dataset.featuredMedia}));
    });
    // Drawer submission preserves the complete FormData, including app properties and selling plans.
    if (sticky) {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }, {threshold: 0});
      observer.observe(button);
      product._smObserver = observer;
    }
  };
  const init = (root = document) => {
    root.querySelectorAll('[data-sm-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-sm-product]').forEach(initProduct);
  };
  const syncStepper = input => {
    const stepper = input.closest('[data-sm-stepper]');
    if (!stepper) return;
    stepper.querySelector('[data-sm-step="-1"]').disabled = input.disabled || Number(input.value) <= Number(input.min || 0);
    stepper.querySelector('[data-sm-step="1"]').disabled = input.disabled || (input.max !== '' && Number(input.value) >= Number(input.max));
  };
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-sm-step]');
    if (!control || control.disabled) return;
    const input = control.closest('[data-sm-stepper]').querySelector('input');
    if (input.disabled) return;
    const previous = input.value;
    if (control.dataset.smStep === '1') input.stepUp(); else input.stepDown();
    syncStepper(input);
    if (input.value !== previous) {
      input.dispatchEvent(new Event('input', {bubbles:true}));
      input.dispatchEvent(new Event('change', {bubbles:true}));
    }
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-sm-stepper] input')) syncStepper(event.target);
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.sm-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('nav a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.sm-mobile-menu[open]').forEach(menu => {menu.open = false; menu.querySelector('summary').focus();});
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-sm-product]').forEach(p => p._smObserver?.disconnect()));
  init();
})();

// SnugMiles cart drawer: Shopify remains the source of cart totals and availability.
(() => {
  if (document.querySelector('#sm-cart-drawer')) return;
  const cartLink = document.querySelector('.sm-cart-link');
  if (!cartLink || !window.HTMLDialogElement) return;
  const cartURL = new URL(cartLink.href, location.origin);
  const drawer = document.createElement('dialog');
  drawer.id = 'sm-cart-drawer';
  drawer.className = 'sm-cart-drawer';
  drawer.setAttribute('aria-labelledby', 'sm-drawer-title');
  drawer.innerHTML = '<header class="sm-drawer-header"><div><p>GOOD THINGS AHEAD</p><h2 id="sm-drawer-title">Your travel bag.</h2></div><button type="button" class="sm-drawer-close" aria-label="Close shopping bag">×</button></header><div class="sm-drawer-message" role="status" aria-live="polite"></div><div class="sm-drawer-content"></div>';
  document.body.append(drawer);
  const content = drawer.querySelector('.sm-drawer-content');
  const message = drawer.querySelector('.sm-drawer-message');
  const closeButton = drawer.querySelector('.sm-drawer-close');
  let busy = false;
  let previousOverflow = '';
  let opener = null;
  const renderCart = async (response) => {
    if (!response.ok) throw new Error('Please try again. Your bag could not be updated.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const section = doc.querySelector('.sm-cart-page');
    if (!section) throw new Error('Your bag could not be loaded. Please try again.');
    // Give drawer forms their own IDs even when the underlying page is /cart.
    section.querySelectorAll('form[id]').forEach(form => {
      const oldID = form.getAttribute('id');
      section.querySelectorAll('[form]').forEach(control => {
        if (control.getAttribute('form') === oldID) control.setAttribute('form', 'drawer-' + oldID);
      });
      form.setAttribute('id', 'drawer-' + oldID);
    });
    section.querySelectorAll('script').forEach(script => script.remove());
    const scrollPositions = ['.sm-cart-items', '.sm-cart-extras'].map(selector => [selector, content.querySelector(selector)?.scrollTop || 0]);
    const style = section.nextElementSibling;
    content.replaceChildren(document.importNode(section, true));
    if (style && style.tagName === 'STYLE') content.append(document.importNode(style, true));
    scrollPositions.forEach(([selector, top]) => { const area = content.querySelector(selector); if (area) area.scrollTop = top; });
    const updatedLink = doc.querySelector('.sm-cart-link');
    if (updatedLink) document.querySelectorAll('.sm-cart-link').forEach(link => {
      const count = link.querySelector('.sm-cart-count');
      const updatedCount = updatedLink.querySelector('.sm-cart-count');
      if (count && updatedCount) count.textContent = updatedCount.textContent;
      if (updatedLink.hasAttribute('aria-label')) link.setAttribute('aria-label', updatedLink.getAttribute('aria-label'));
    });
  };
  const request = async (url, options = {}) => {
    if (busy) return;
    busy = true;
    content.setAttribute('aria-busy', 'true');
    message.textContent = content.children.length ? 'Updating your bag…' : 'Loading your bag…';
    const controls = [...content.querySelectorAll('button, input, textarea, select')];
    controls.forEach(control => { control.dataset.smWasDisabled = String(control.disabled); control.disabled = true; });
    let succeeded = false;
    try {
      const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store', ...options});
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(typeof errorData.description === 'string' ? errorData.description : 'Please try again. Your bag could not be updated.');
      }
      const cartResponse = options.method === 'POST'
        ? await fetch(cartURL, {credentials: 'same-origin', cache: 'no-store'})
        : response;
      await renderCart(cartResponse);
      message.textContent = 'Your bag is up to date.';
      succeeded = true;
    } catch (error) {
      message.textContent = error.message || 'Please try again. Your bag could not be updated.';
      if (!content.children.length) {
        const retry = document.createElement('button');
        retry.type = 'button'; retry.className = 'sm-button'; retry.textContent = 'Try again';
        retry.addEventListener('click', () => request(cartURL)); content.append(retry);
      }
    } finally {
      controls.forEach(control => { control.disabled = control.dataset.smWasDisabled === 'true'; delete control.dataset.smWasDisabled; });
      content.removeAttribute('aria-busy');
      busy = false;
    }
    return succeeded;
  };
  const open = (trigger, load = true) => {
    if (drawer.open) return;
    opener = trigger;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    drawer.showModal();
    closeButton.focus();
    if (load) request(cartURL);
  };
  window.SnugMilesCart = {open: () => open(document.activeElement), refresh: () => request(cartURL)};
  document.addEventListener('sm:cart:open', () => { open(document.activeElement, false); request(cartURL); });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.sm-buy-form') || event.defaultPrevented) return;
    event.preventDefault();
    if (busy || form.dataset.smAdding === 'true') return;
    const body = new FormData(form);
    body.delete('return_to');
    const action = new URL(form.action, location.origin);
    action.pathname = action.pathname.replace(/\/$/, '') + '.js';
    const controls = [...form.querySelectorAll('button[type="submit"]'), ...document.querySelectorAll('button[form="' + form.id + '"]')];
    const states = controls.map(control => control.disabled);
    controls.forEach(control => { control.disabled = true; });
    form.dataset.smAdding = 'true';
    open(event.submitter || form.querySelector('button'), false);
    const added = await request(action, {method:'POST', body});
    const status = form.querySelector('.sm-cart-status');
    if (status) status.textContent = added ? 'Added to your bag.' : message.textContent;
    controls.forEach((control, i) => { control.disabled = states[i]; });
    delete form.dataset.smAdding;
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('button[data-sm-upsell]');
    if (!button) return;
    event.preventDefault();
    if (busy) return;
    const selected = button.dataset.added !== 'true';
    if (!drawer.contains(button)) open(button, false);
    const endpoint = cartURL.pathname.replace(/\/$/, '') + (selected ? '/add.js' : '/update.js');
    const payload = selected
      ? {items:[{id:Number(button.dataset.variantId),quantity:1}]}
      : {updates:JSON.parse(button.dataset.removeUpdates)};
    await request(endpoint, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload)});
    content.querySelector('[data-sm-upsell="' + button.dataset.smUpsell + '"]')?.focus({preventScroll:true});
  });
  document.addEventListener('change', async event => {
    const input = event.target.closest('[data-sm-quantity]');
    if (!input) return;
    if (busy || !input.validity.valid || input.value === '') {
      input.value = input.dataset.originalQuantity; return;
    }
    const quantity = Number(input.value);
    if (quantity === Number(input.dataset.originalQuantity)) return;
    if (!drawer.contains(input)) open(input, false);
    const ok = await request(cartURL.pathname.replace(/\/$/, '') + '/change.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:input.dataset.lineKey, quantity})
    });
    if (!ok && input.isConnected) input.value = input.dataset.originalQuantity;
    [...content.querySelectorAll('[data-sm-quantity]')].find(control => control.dataset.lineKey === input.dataset.lineKey)?.focus({preventScroll:true});
  });
  closeButton.addEventListener('click', () => drawer.close());
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const box = drawer.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) drawer.close();
  });
  drawer.addEventListener('close', () => { document.body.style.overflow = previousOverflow; opener?.focus(); });
  document.addEventListener('click', event => {
    const link = event.target.closest('a.sm-cart-link');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); open(link);
  });
  content.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.origin);
    if (url.origin === location.origin && url.pathname === cartURL.pathname.replace(/\/$/, '') + '/change') {
      event.preventDefault(); request(url);
    }
  });
  content.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (event.submitter?.name === 'checkout') return;
    event.preventDefault();
    if (busy) return;
    const body = new FormData(form);
    if (event.submitter?.name) body.append(event.submitter.name, event.submitter.value);
    body.delete('return_to');
    body.delete('update');
    const actionURL = new URL(form.action, location.origin);
    actionURL.pathname = actionURL.pathname === cartURL.pathname ? cartURL.pathname + '/update.js' : actionURL.pathname + '.js';
    request(actionURL, {method: 'POST', body});
  });
})();
